import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
import { Fragment, useMemo } from 'react';
import cn from 'classnames';
import { css } from 'styled-components';
import CloseSmall from '@crehana/icons/outline/CloseSmall';
import { BaseButton, colors, IconButton, PrimaryButton, TextTag } from '@crehana/ui';
import { REMAINING_SECONDS_TO_SKIP } from "../constants";
import { usePlaybackContext } from "../context/Playback";
import { useResponsiveContext } from "../context/Responsive";
import { useUIContext } from "../context/UI";
import { useTranslation } from "../hooks";
import ButtonPercentage from "./ui/ButtonPercentage";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SkipButton = function SkipButton(_ref) {
  var nextVideoTitle = _ref.nextVideoTitle;
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var _usePlaybackContext = usePlaybackContext(),
    visibleSkip = _usePlaybackContext.visibleSkip,
    remainingSeconds = _usePlaybackContext.remainingSeconds,
    onSkip = _usePlaybackContext.onSkip,
    onSkipDismiss = _usePlaybackContext.onSkipDismiss;
  var _useUIContext = useUIContext(),
    autoplayNext = _useUIContext.autoplayNext,
    visibleUi = _useUIContext.visibleUi,
    putOpenedSkipAI = _useUIContext.putOpenedSkipAI,
    getOpenedSkipAI = _useUIContext.getOpenedSkipAI,
    toogleGeneratedAI = _useUIContext.toogleGeneratedAI;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isFirstOpenedAI = !getOpenedSkipAI();
  var calculatePercentage = useMemo(function () {
    if (remainingSeconds >= REMAINING_SECONDS_TO_SKIP) return '100%';
    var percentage = -9 / 10 * (remainingSeconds / REMAINING_SECONDS_TO_SKIP * 100) + 90;
    return "".concat(Math.ceil(percentage), "%");
  }, [remainingSeconds]);
  var handleSkip = function handleSkip() {
    onSkipDismiss();
    putOpenedSkipAI();
  };
  var handleGeneratedAI = function handleGeneratedAI() {
    onSkipDismiss();
    putOpenedSkipAI();
    toogleGeneratedAI('AI SkipButton');
  };
  if (playerSize.matches.md) {
    return /*#__PURE__*/_jsx(_StyledDiv, {
      className: cn('cp-skip-desktop tw-absolute tw-flex tw-flex-col tw-z-5 ', visibleSkip ? 'cui-is-visible' : 'cui-is-hidden'),
      $_css: visibleUi ? 'transform: translateY(-68px);' : '',
      children: /*#__PURE__*/_jsxs("div", {
        className: cn('tw-rounded-1 tw-p-2.4  tw-flex tw-flex-col tw-items-end tw-bg-elevation-dark-02', {
          'tw-pt-3.6': isFirstOpenedAI
        }),
        children: [/*#__PURE__*/_jsxs("div", {
          className: cn('tw-bg-elevation-dark-04 tw-p-2.4 tw-w-full tw-flex-col tw-rounded-1 tw-mb-1.6', isFirstOpenedAI ? 'tw-flex' : 'tw-hidden'),
          children: [/*#__PURE__*/_jsx(TextTag, {
            label: t('AI_TAG'),
            type: "green",
            className: "tw-absolute tw-w-fit tw-top-2.4 tw-bg-secondary-dark-400 tw-rounded-full tw-text-neutral-light-800 tw-font-caption"
          }), /*#__PURE__*/_jsx("span", {
            className: "tw-font-subtitle4 mb-8 tw-text-neutral-light-100",
            children: t('AI_LABEL_TITLE')
          }), /*#__PURE__*/_jsx("span", {
            className: "tw-font-body4 text-gray-light",
            children: t('AI_DESCRIPTION_SHORT')
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "tw-w-full tw-flex tw-items-center tw-justify-between tw-mb-0.4",
          children: [/*#__PURE__*/_jsxs("span", {
            className: "tw-font-label1 tw-text-primary-dark-400",
            children: [t('NEXT_LECTURE'), ":"]
          }), /*#__PURE__*/_jsx(IconButton, {
            customIcon: CloseSmall,
            customColor: colors.baseLighter,
            xs: true,
            onClick: handleSkip,
            "aria-label": t('CLOSE'),
            style: {
              width: 24,
              height: 24
            }
          })]
        }), /*#__PURE__*/_jsx("span", {
          className: "tw-font-subtitle4 tw-text-neutral-light-100 tw-w-full tw-mb-1.6 tw-line-clamp-2",
          children: nextVideoTitle
        }), /*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-items-center tw-justify-between tw-w-full",
          children: [/*#__PURE__*/_jsx("button", {
            type: "button",
            className: "tw-btn-inverse-xs tw-btn-white tw-font-link2 tw-mr-1.2 tw-flex tw-items-center tw-justify-center tw-w-[50%]",
            onClick: handleGeneratedAI,
            children: t('AI_CTA_BUTTON')
          }), /*#__PURE__*/_jsx(ButtonPercentage, {
            label: t('NEXT_LECTURE'),
            onSkip: onSkip,
            sizePercentage: calculatePercentage,
            autoplayNext: autoplayNext
          })]
        })]
      })
    });
  }
  var mobileSkipCss = /*#__PURE__*/css(["\n    bottom: 8px;\n    right: 8px;\n  "]);
  var mobileLandscapeSkipCss = /*#__PURE__*/css(["\n    bottom: 16px;\n    right: 24px;\n  "]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: cn('cp-skip-gradient-wrapper absolute inset-0 z-1', visibleSkip && !visibleUi ? 'cui-is-visible' : 'cui-is-hidden'),
      children: /*#__PURE__*/_jsx("div", {
        className: "relative w-full h-full overflow-hidden",
        children: /*#__PURE__*/_jsx(_StyledDiv2, {
          className: "cp-skip-gradient absolute bottom-0 right-0 opacity-50 z-1",
          $_css2: playerSize.matches.xs ? '-257px' : '-400px'
        })
      })
    }), /*#__PURE__*/_jsx(_StyledDiv3, {
      className: "cp-skip-mobile absolute z-5 ".concat(visibleSkip && !visibleUi ? 'cui-is-visible' : 'cui-is-hidden'),
      $_css3: playerSize.matches.xs ? mobileLandscapeSkipCss : mobileSkipCss,
      children: autoplayNext ? /*#__PURE__*/_jsxs(BaseButton, {
        onClick: onSkip,
        className: cn('px-16 bg-purple-lighter rounded-5 overflow-hidden relative', playerSize.matches.sm ? 'h-40' : 'h-32'),
        children: [/*#__PURE__*/_jsx(_StyledDiv4, {
          "data-testid": "skip-button-mobile-progress",
          className: "absolute top-0 left-0 h-full bg-purple-light",
          $_css4: remainingSeconds >= REMAINING_SECONDS_TO_SKIP ? 0 : Math.ceil((REMAINING_SECONDS_TO_SKIP - remainingSeconds) / REMAINING_SECONDS_TO_SKIP * 100)
        }), /*#__PURE__*/_jsx("span", {
          className: "font-link tw-text-neutral-light-100 z-1",
          children: t('SKIP_VIDEO')
        })]
      }) : /*#__PURE__*/_jsx(PrimaryButton, {
        label: t('SKIP_VIDEO'),
        onClick: onSkip,
        size: playerSize.matches.sm ? 's' : 'xs',
        isDark: true
      })
    })]
  });
};
export default SkipButton;
var _StyledDiv = /*#__PURE__*/_styled("div")(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n          right: 8px;\n          bottom: 24px;\n          width: 50%;\n          max-width: 432px;\n          ", "\n        "])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = /*#__PURE__*/_styled2("div")(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteral(["\n              width: 940px;\n              height: 159px;\n              bottom: -49px;\n              right: ", ";\n              background-image: radial-gradient(\n                37.5% 37.5% at 50% 50%,\n                ", " 0%,\n                rgba(24, 27, 50, 0) 100%\n              );\n            "])), function (p) {
  return p.$_css2;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.base.main;
});
var _StyledDiv3 = /*#__PURE__*/_styled3("div")(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv4 = /*#__PURE__*/_styled4("div").withConfig({
  componentId: "sc-15r9lra-0"
})(["\n                width: ", "%;\n                transition: ", ";\n              "], function (p) {
  return p.$_css4;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition('width');
});